import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import mutations from './mutations'
import * as types from './mutation-types'
import QuizPlayerApi from '../api'

Vue.use(Vuex)

export function quizPlayerStore(target, data, options = {}) {
  const state = {
    questions: [
      /*
        {
          id,
          content,
          answers[{ id, content }]
        }
      */
    ],
    take: {
      /*
        {
          question_takes_count,
          quiz_passed,
          score,
        }
      */
    },
    currentQuestion: null,
    currentAnswer: null,
    currentQuestionResult: null, // { correct }
    triesCounter: {},
    isStudyGuide: options.isStudyGuide || false,
    showSuccessBanner: false,
    study_guide_player: {
      hidden: true
    }
  }

  const api = new QuizPlayerApi(target, options)

  const actions = {
    setAnswer({ commit }, answerId) {
      commit(types.ANSWER_SELECTED, answerId)
    },

    submitAnswer({ commit, state }) {
      if (!state.currentAnswerId) return

      const questionId = state.currentQuestionId
      const tryNumber = state.triesCounter[questionId] || 0
      api.submitAnswer(questionId, state.currentAnswerId, tryNumber,
        (result, take) => commit(types.SUBMIT_ANSWER,
          { questionId: questionId, result, take })
      )
    },

    nextQuestion({ commit }) {
      commit(types.NEXT_QUESTION)
    },

    resultsNextQuestion({ commit }) {
      commit(types.GO_TO_THE_QUESTION, 1)
    },

    resultsPreviousQuestion({ commit }) {
      commit(types.GO_TO_THE_QUESTION, -1)
    },

    openPlayer({ commit }) {
      commit(types.TRIGGER_STUDY_GUIDE_PLAYER, false)
    },

    closePlayer({ commit }) {
      commit(types.TRIGGER_STUDY_GUIDE_PLAYER, true)
      commit(types.CLOSE_SUCCESS_BANNER)
    }
  }

  const store = new Vuex.Store({
    state,
    actions,
    getters,
    mutations
  })

  store.commit(types.LOAD_QUIZ_TAKE, data)

  return store;
}
